var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.6726 2.32701c-.703-.70294-1.8426-.70294-2.5456 0l-6.8272 6.82721v2.54558h2.54558l6.82722-6.8272c.7029-.70295.7029-1.84264 0-2.54559z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.7998 5.3998c0-.99411.80589-1.8 1.8-1.8h3.6c.49706 0 .9.40295.9.9 0 .49706-.40294.9-.9.9h-3.6v9h9v-3.6c0-.4971.4029-.89999.9-.89999s.9.40289.9.89999v3.6c0 .9941-.8059 1.8-1.8 1.8h-9c-.99411 0-1.8-.8059-1.8-1.8z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.356b454e579391dd30170b0cc79de15f.svg";
export { ForwardRef as ReactComponent };